import { CurrentUserDetails } from '../models/CurrentUserDetails';

const formatFullName = (currentUserDetails: CurrentUserDetails | null | undefined): string =>
  `${currentUserDetails?.firstname ?? ''} ${currentUserDetails?.middleinitial ?? ''} ${
    currentUserDetails?.lastname ?? ''
  }`
    .replace(/\s+/g, ' ')
    .trim();
export default formatFullName;
